export default __webpack_public_path__ + "static/media/Admin.42426135.svg";